import { render, staticRenderFns } from "./resolveAddress.vue?vue&type=template&id=4c9996e9&scoped=true"
import script from "./resolveAddress.vue?vue&type=script&lang=js"
export * from "./resolveAddress.vue?vue&type=script&lang=js"
import style0 from "./resolveAddress.vue?vue&type=style&index=0&id=4c9996e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9996e9",
  null
  
)

export default component.exports